__turbopack_context__.v({
  "className": "merriweather_fa93ec6e-module__mo-fzG__className",
  "variable": "merriweather_fa93ec6e-module__mo-fzG__variable",
});
